﻿export enum MessageLanguageEnum {
	FR = 'FR',
	EN = 'EN',
}

export enum MessageAudienceEnum {
	ALL = 'ALL',
	ALL_IOS = 'ALL-IOS',
	ALL_ANDROID = 'ALL-ANDROID',
	SPECIFIC = 'SPECIFIC',
}

export enum MessageAudienceLabelEnum {
	ALL = 'Tous les utilisateurs Heyama',
	ALL_IOS = 'Tous les utilisateurs iPhone',
	ALL_ANDROID = 'Tous les utilisateurs Android',
	SPECIFIC = 'Utilisateurs sélectionnés',
}

export enum AdminMessageStatusEnum {
	PENDING = 'PENDING',
	COMPLETED = 'COMPLETED',
	CANCELLED = 'CANCELLED',
	ERROR = 'ERROR',
}

export enum AdminMessageModeEnum {
	MANUAL = 'manual',
	AUTO = 'auto',
}

export enum ReligionEnum {
	CATHOLIC = 'CATHOLIC',
	PROTESTANT = 'PROTESTANT',
	ISLAM = 'ISLAM',
	HINDU = 'HINDU',
	ATHEIST = 'ATHEIST',
	CHRISTIAN = 'CHRISTIAN',
	PENTECOSTAL = 'PENTECOSTAL',
	NO_ANSWER = 'NO_ANSWER',
}
